import React from 'react';

// Simple inline stubs for UI components from the rocket project
export const Icon = ({ name, size = 16, className = '' }) => {
  const sizeStr = size + 'px';
  return <span className={className} style={{ display: 'inline-flex', width: sizeStr, height: sizeStr }} />;
};

export const Button = ({ children, onClick, variant, disabled, className = '', iconName, size: btnSize, loading, ...rest }) => (
  <button onClick={onClick} disabled={disabled || loading} className={`px-4 py-2 rounded-lg font-medium transition-colors ${variant === 'outline' ? 'border border-border bg-card text-gray-700 hover:bg-gray-50' : 'bg-blue-600 text-white hover:bg-blue-700'} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`} {...rest}>{loading ? 'Loading...' : children}</button>
);

export const Input = ({ className = '', label, error, ...props }) => (
  <div>
    {label && <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>}
    <input className={`border border-border rounded-lg px-3 py-2 text-sm focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:border-primary focus-visible:outline-none ${className}`} {...props} />
    {error && <p className="text-xs text-red-600 mt-1">{error}</p>}
  </div>
);

export const Select = ({ value, onChange, options, placeholder, className = '', label, error }) => (
  <div>
    {label && <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>}
    <select value={value} onChange={e => onChange(e.target.value)} className={`border border-border rounded-lg px-3 py-2 text-sm focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:border-primary focus-visible:outline-none bg-card ${className}`}>
      {placeholder && <option value="">{placeholder}</option>}
      {options?.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
    </select>
    {error && <p className="text-xs text-red-600 mt-1">{error}</p>}
  </div>
);

export const Checkbox = ({ checked, onChange, label, className = '' }) => (
  <label className={`flex items-center space-x-2 cursor-pointer ${className}`}>
    <input type="checkbox" checked={checked} onChange={onChange} className="rounded border-border text-blue-600 focus-visible:ring-primary/20" />
    {label && <span className="text-sm text-gray-700">{label}</span>}
  </label>
);

export default Icon;
